/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ModeCalculTarification } from './ModeCalculTarification';
import {
    ModeCalculTarificationFromJSON,
    ModeCalculTarificationFromJSONTyped,
    ModeCalculTarificationToJSON,
    ModeCalculTarificationToJSONTyped,
} from './ModeCalculTarification';

/**
 * Taxe d'une garantie du tunnel, en écriture. Trois intentions se distinguent, et le champ `modeCalcul` est volontairement facultatif pour les rendre toutes exprimables :
 * 
 *   * champ absent (ou null)          → la taxe en place est conservée ;
 *   * bloc présent sans `modeCalcul`  → suppression explicite de la taxe ;
 *   * bloc présent avec `modeCalcul`  → la taxe est créée ou remplacée.
 * 
 * Un bloc vide `{}` vaut donc suppression, là où omettre le champ ne touche à rien.
 * @export
 * @interface TaxeCommandDto
 */
export interface TaxeCommandDto {
    /**
     * 
     * @type {ModeCalculTarification}
     * @memberof TaxeCommandDto
     */
    modeCalcul?: ModeCalculTarification;
    /**
     * 
     * @type {number}
     * @memberof TaxeCommandDto
     */
    montantFixe?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TaxeCommandDto
     */
    montantFixeHT?: number | null;
    /**
     * Multiplicateur appliqué au prix HT — 1,09 vaut 9 %, et non 1,09 %.
     * @type {number}
     * @memberof TaxeCommandDto
     */
    taux?: number | null;
    /**
     * 
     * @type {string}
     * @memberof TaxeCommandDto
     */
    expression?: string | null;
}



/**
 * Check if a given object implements the TaxeCommandDto interface.
 */
export function instanceOfTaxeCommandDto(value: object): value is TaxeCommandDto {
    return true;
}

export function TaxeCommandDtoFromJSON(json: any): TaxeCommandDto {
    return TaxeCommandDtoFromJSONTyped(json, false);
}

export function TaxeCommandDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaxeCommandDto {
    if (json == null) {
        return json;
    }
    return {
        
        'modeCalcul': json['modeCalcul'] == null ? undefined : ModeCalculTarificationFromJSON(json['modeCalcul']),
        'montantFixe': json['montantFixe'] == null ? undefined : json['montantFixe'],
        'montantFixeHT': json['montantFixeHT'] == null ? undefined : json['montantFixeHT'],
        'taux': json['taux'] == null ? undefined : json['taux'],
        'expression': json['expression'] == null ? undefined : json['expression'],
    };
}

export function TaxeCommandDtoToJSON(json: any): TaxeCommandDto {
    return TaxeCommandDtoToJSONTyped(json, false);
}

export function TaxeCommandDtoToJSONTyped(value?: TaxeCommandDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'modeCalcul': ModeCalculTarificationToJSON(value['modeCalcul']),
        'montantFixe': value['montantFixe'],
        'montantFixeHT': value['montantFixeHT'],
        'taux': value['taux'],
        'expression': value['expression'],
    };
}

